var React = require('react');

function CarInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"currentColor","cx":"6","cy":"14","r":"1","key":0}),React.createElement("circle",{"fill":"currentColor","cx":"18","cy":"14","r":"1","key":1}),React.createElement("path",{"d":"M4 10c.52-1.232.996-2.336 1.427-3.31C6.397 4.498 6.617 4 8.757 4h6.661c2.141 0 2.361.498 3.33 2.69.431.974.849 2.078 1.252 3.31","stroke":"currentColor","strokeWidth":"2","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M6 18v2m12-2v2M4 10h16a2 2 0 0 1 2 2v6H2v-6a2 2 0 0 1 2-2z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":3})]));
}

CarInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = CarInline;

CarInline.default = CarInline;
